export default function useDebounce(func, timeout = 300) {
  let timer;
  return (...args) => {
    clearTimeout(timer);
    timer = setTimeout(() => { func(...args); }, timeout);
  };
}



// WEBPACK FOOTER //
// ./node_modules/@intelipost-modules/secure-recon/features/billing/shared/FctnDebounce.js